import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useGroupGuid } from 'components/IAP/hooks/commonHooks';
import apiConfig from 'constants/apiConfig';

interface GetExternalOrganizationsResponse {
  externalOrganizations: {
    id: string;
    groupId: string;
    organizationName: string;
  }[];
}

export const useGetExternalOrganizations = (
  onSuccess?: (data: GetExternalOrganizationsResponse) => void
) => {
  const groupId = useGroupGuid();

  return useQuery({
    queryKey: ['externalOrganizations', groupId],
    queryFn: async () => {
      const response = await axios.get<GetExternalOrganizationsResponse>(
        `${apiConfig.apiGateway.externalUsers}/externalOrganizations/${groupId}`
      );

      if (onSuccess) {
        onSuccess(response.data);
      }

      return response.data;
    },
    staleTime: 0,
  });
};
